module.exports = __webpack_public_path__ + "static/img/Nic_Naitanui_desktop.54168a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nic_Naitanui_desktop.jpg
// module id = OB0Z
// module chunks = 0